import styled, {ThemeProvider} from 'styled-components'
import {lighten, darken} from 'polished'

export default styled.input`
  outline: none;
  border: 1px solid ${props => props.theme.color};
  display: block;
  border-radius: 8px;
  padding: 15px 20px;
  text-decoration: none;
  color: black;
  background: white;
  * {
    pointer-events: none;
    cursor: pointer;
  }
  ${'' /* :hover {
    background: ${props => lighten(0.05, props.theme.color)};
  }
  :active {
    background: ${props => darken(0.05, props.theme.color)};
  } */};
`



// WEBPACK FOOTER //
// ./src/components/input.js